import FetchService from "./Shared/FetchService";
const advisorUrl = "/aviso/advisor";
export default class CourseBasedSuccesScoringService {
    static getScoreReasons(transcriptCourseId, affiliationId) {
        return FetchService.getSingleResponse(advisorUrl + "/getTranscriptCourseSuccessScoreReasons", { transcriptCourseId, affiliationId });
    }
}
